module.exports = __webpack_public_path__ + "img/bank-info.e34fbb8a.svg";